
function changeForm(value) {
	switch(value) {
		case 'Effectuer un devis':
			initConversationalForm();
		break;

		default:
		break;
	}
}

function initConversationalForm() {
	document.getElementById("devis-form").removeAttribute('hidden');
	var conversationalForm = window.cf.ConversationalForm.startTheConversation({
	  formEl: document.getElementById("devis-form"),
	  context: document.getElementById("form-placeholder"),
	  userImage: "https://gulpjs.com/img/gulp-white-text.svg",
	  robotImage: "/content/themes/5x5/img/SolidFavicon1.png",
	  loadExternalStyleSheet: true,
	  //preventAutoFocus: true,
	  dictionaryData: {
	  		"input-placeholder": "Saisissez votre réponse...",
	  		"user-reponse-missing": "Non renseigné",
	  		"input-placeholder-required": "Veuillez remplir ce champ",
	  		"input-placeholder-error": "Réponse invalide, veuillez réessayer",
	  },
	  flowStepCallback: validateStep,
	  submitCallback: function() {
	  	var data = conversationalForm.getFormData(true);
	  	console.log(data);
	  	var barges = (data.unity[0] == 'm3') ? Math.ceil(data.amount / 600) : Math.ceil(data.amount / 1200);
	  	var trucks = (data.unity[0] == 'm3') ? Math.ceil(data.amount / 14) : Math.ceil(data.amount / 28);
	  	var informationLine = (data.amountbool[0] == 'oui') ? "Pour information, "+ data.amount +" "+ data.unity[0]+" equivalent à "+ barges + " péniche(s) et " + trucks+ " camion(s) semi-remorques" : '';
	    var connector = (data.amountbool[0] == 'oui') ? '&&' : ' <br/>';
	    conversationalForm.addRobotChatResponse("Votre demande a bien été prise en compte"+ connector + informationLine);
	    submitConversationalForm(conversationalForm);
	  },
	});
}


function validateStep(dto, success, error) {
	//console.log("dto...", dto, success, error);
	var value = dto.text.toString();
	//console.log(value);
	var elem = dto.tag.name;
	switch(dto.tag.type) {
		case 'number':
			if(/^[0-9]*$/.test(value)){
				return success();
			} else {
				 return error();
			}
			break;
		case 'email':
			if(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)){
				return success();
			} else {
				return error();
			}
			break;
		case 'phone':
			if(/^[0-9]{10}$/.test(value)) {
				return success();
			} else {
				return error();
			}
			break;
		default:
			return success();
			break;
	}

}

function submitConversationalForm(form) {
	var formData = form.getFormData();
	var valueData = form.getFormData(true);
	if(valueData.amountbool[0] =='oui') {
		formData.append('quantity', valueData.amount + valueData.unity[0]);
	}
	formData.append('action', 'contact_conversational_form');
	$.ajax({
		url: ajaxurl,
		data: formData,
		processData: false,
		contentType: false,
		type: 'POST',
		success: function(data) {
			console.log("success");
		},
		error: function(xhr, status, error) {
            console.log(xhr, status, error);
		}
	});
}